import React from 'react';

function PostContainer(Component, params) {
    
    const mainContainer = (props) => {
        
        let [totalRecords, setTotalRecords] = React.useState(0);
        const [pagination, setPagination] = React.useState({
            page: 0,
            page_limit: 10,
        })

        
        const [order, setOrder] = React.useState({
            order_by: `${params.defaultOrderBy}`,
            direction: 'desc'
        })

        /*React.useEffect(() => {
            setTotalRecords(props.totalRecord);
        }, [props.totalRecord]);*/

        const options = {
            tableId:'datatable',
            filterType: 'checkbox',
            search: false,
            responsive: "simple",
            filter: false,
            download: false,
            print: false,
            selectableRows: 'none',
            viewColumns: false,
            count: totalRecords,
            serverSide: (props.serverSide!==undefined)?props.serverSide:true,
            page: pagination.page,
            rowsPerPage: pagination.page_limit,
            onColumnSortChange: (changedColumn) => {
                setOrder({
                    order_by: changedColumn,
                    direction: (order.direction === 'asc') ? 'desc' : 'asc'
                })

            },
            onTableChange: (action, tableState) => {
                switch (action) {
                    case 'changePage':
                        setPagination({
                            page_limit: pagination.page_limit,
                            page: tableState.page
                        })
                        break;
                    case 'changeRowsPerPage':
                        setPagination({
                            page_limit: tableState.rowsPerPage,
                            page: 0,
                        })
                        break;
                    default:
                        break
                }
            }
        };

        const getTotalCount = (count) =>{
            setTotalRecords(count);
        }
        return (
            <Component {...props} getTotalCount={getTotalCount} options={options} columns={[]} pagination={pagination} order={order} />
        );
    }
    

    return mainContainer;
}

export default PostContainer;
